import * as sojern from './Sojern'
import * as ug from './user-guest'
import * as thn from './thn'

export function searchPageTracking(cart, property, rooms) {
  // Sojern
  sojern.search(cart, property)

  // User Guest
  ug.init()

  // The Hotels Network
  thn.search(cart, property, rooms)
}

export function extrasPageTracking() {
  // User Guest
  ug.init()

  // The Hotels Network
  // thn.init()
}

export function bookingPageTracking(cart, property) {
  // Sojern
  sojern.shoppingCart(cart, property)

  // User Guest
  ug.init()

  // The Hotels Network
  // thn.init()
}

export function confirmationPageTracking(cart, property, bookingID) {
  // Sojern
  sojern.confirmation(cart, property, bookingID)

  // User Guest
  ug.confirmation(cart, property, bookingID)

  // The Hotels Network
  thn.confirmation(cart, property, bookingID)
}

export function terminateTracking() {
  // Sojern
  sojern.terminate()

  // User Guest
  ug.terminate()

  // The Hotels Network
  thn.terminate()
}
